import {Account} from "./account";

export class QueueMember {
    id: number;
    name: string;
    penalty: number;
    accountId: number;
    account: Account;
}
